export enum LocalStorageKey {
  APP_TOKEN = "app-token",
  USER_TOKEN = "user-token",
  INVOICES_PATIENTS_HISTORICAL_SEARCH = "invoices_patient_historical_search",
  PAYMENT_RECEIPTS_PATIENTS_HISTORICAL_SEARCH = "payment_receipts_patient_historical_search",
  ON_BOARDING_DATA = "on_boarding_data",
  PRIVACY_PIN_CODE = "privacy_pin_code",
  PRIVACY_DATE = "privacy_date",
  PRIVACY_BIO = "privacy_bio",
  PRIVACY_BIO_CHECKED = "privacy_bio_checked",
}
